export enum ActionType {
  SET_BODYPART = 'SET_BODYPART',
}
